module.exports = __webpack_public_path__ + "img/login-o.ab31ce54.svg";